import { useRouteMatch } from 'react-router-dom';

// Matches up to the intent segment so step components can navigate to siblings
// without reconstructing the full URL from params.
const ACTIVATION_BASE_PATTERN = '/activate/sleepio-canopy/:lob/:org_slug/:intent';

/**
 * Returns the base URL for the current activation flow, e.g.
 *   /activate/sleepio-canopy/wellness/acme-corp/sign-up
 *
 * Step components append step segments to this (e.g. `${base}/otp`) for
 * history.push calls. Centralising the URL knowledge here means if the parent
 * route path ever changes, only this file needs updating.
 */
// eslint-disable-next-line import/prefer-default-export
export const useActivationBase = (): string => {
  const match = useRouteMatch(ACTIVATION_BASE_PATTERN);
  return match?.url ?? '';
};
